import React from "react";
import { useParams } from "react-router-dom";
import { BeratungLayout } from "@/components/beratung/BeratungLayout";

export default function Beratung() {
  const { sessionId } = useParams<{ sessionId?: string }>();
  
  return <BeratungLayout sessionId={sessionId} />;
}
